module.exports = __webpack_public_path__ + "media/images/create-encounter-d9e20a195d1226a85381bb54260ff0e6.svg";